var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('a-header',{on:{"openOrders":_vm.openOrders}}),_c('customer-service'),_c('div',{staticClass:"bg"}),_c('router-view'),_c('orders',{attrs:{"orderDialogVisible":_vm.orderDialogVisible},on:{"closeOrders":_vm.closeOrders,"payNow":_vm.payNow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }